import { SectionLabel } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'
import { SubInfoBlock } from '../styles'

export const HostInfoContainer = styled(SubInfoBlock)`
  justify-content: space-between;
  min-height: 176px;

  @media ${theme.devices.tablet} {
    min-height: 172px;
  }
`

export const HostInfoHeaderContainer = styled(SectionLabel)`
  min-height: unset;
  margin: unset;
`

export const HostInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const HostTypeLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: black;
`
